import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Select, { components } from "react-select";
import MaterialReactTable from "material-react-table";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Box, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import AdminHeaderNew from "../NewAdminPanel/Common/AdminHeader";
import AdminSideBarNew from "../NewAdminPanel/Common/AdminSideBar";
import AdminFooterNew from "../NewAdminPanel/Common/AdminFooter";
import { ExportToCsv } from "export-to-csv";
import * as XLSX from "xlsx"; // npm install xlsx

const validSchemeCodesForSeedDemonstration = ["20", "9", "8", "5", "15","14"];

const getFirstValue = (row, keys) => {
    for (const key of keys) {
        if (row && Object.prototype.hasOwnProperty.call(row, key)) {
            const value = row[key];
            if (value !== undefined && value !== null) {
                return value;
            }
        }
    }
    return "";
};

const getPrimaryInputDetails = (farmer) => {
    if (!farmer || !Array.isArray(farmer.inputDetails)) {
        return {};
    }
    return farmer.inputDetails[0] || {};
};

const AssetsReports = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState("");
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState("");
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState("");
    const [financialYearValue, setFinancialYearValue] = useState("All");
    const [demoTypeOptions, setDemoTypeOptions] = useState([]);
    const [demoTypeValue, setDemoTypeValue] = useState(null);
    const [farmerData, setfarmerData] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [LoaderFarmer, setLoaderFarmer] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [infoMessage, setInfoMessage] = useState("");
    const [hasSearched, setHasSearched] = useState(false);
    const [header, setHeader] = useState("");
    const [isStateDisabled, setIsStateDisabled] = useState(false);
    const [isDistrictDisabled, setIsDistrictDisabled] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [assetDetails, setAssetDetails] = useState(null);
    const [loadingDetails, setLoadingDetails] = useState(false);

    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const isSeedDemoScheme = validSchemeCodesForSeedDemonstration.includes(
        String(schemeCode)
    );

    const baseUrl =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE;

    useEffect(() => {
        fetchDataFilterWise();
        if (!isSeedDemoScheme) {
            navigate("/newadminpanel/farmer");
        }
    }, [isSeedDemoScheme, navigate]);

    useEffect(() => {
        try {
            const navHeader = location?.state?.header
                ? String(location.state.header)
                : "";
            const storedHeader = sessionStorage.getItem("farmerHeader") || "";
            const nextHeader = navHeader || storedHeader || "Seed Demonstration";
            setHeader(nextHeader);

            if (navHeader) {
                sessionStorage.setItem("farmerHeader", navHeader);
            }
        } catch (_) {
            // ignore storage issues
        }
    }, [location]);

    useEffect(() => {
        getStates();
    }, []);


    const getStates = () => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };

        fetch(`${baseUrl}/api/states`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                const localFormDataState = JSON.parse(result).dataContent || [];
                const myArray = localFormDataState.map((item) => ({
                    value: item.stateCode,
                    label: item.stateName,
                }));
                setOptionState(myArray);

                const userType = sessionStorage.getItem("userTypeCodeModel");
                const userTypeValue = Number(userType);
                const userTypeCode = Number.isNaN(userTypeValue) ? 0 : userTypeValue;
                const stateCode = sessionStorage.getItem("stateNameModel");
                const districtCode = sessionStorage.getItem("districtNameModel");

                if (
                    userTypeCode >= 2 &&
                    stateCode &&
                    stateCode !== "null"
                ) {
                    const matchingState = myArray.find(
                        (state) => String(state.value) === String(stateCode)
                    );
                    const nextStateCode = matchingState
                        ? matchingState.value
                        : stateCode;
                    setStateValue([nextStateCode]);
                    setIsStateDisabled(true);
                    handleState(nextStateCode, userTypeCode >= 3 ? districtCode : "");
                } else {
                    setIsStateDisabled(false);
                    setIsDistrictDisabled(false);
                }
            })
            .catch((error) => {
                console.error("Error fetching states:", error);
            });
    };

    const handleState = (stateCodeParam = "", districtCodeParam = "") => {
        const currentStateValue = stateCodeParam ? [stateCodeParam] : stateValue;
        setOptionDistrict([]);
        setDistrictValue("");
        setIsDistrictDisabled(false);
        setOptionSubDistrict([]);
        setsubDistrictValue("");
        setOptionVillage([]);
        setvillageValue("");

        if (!currentStateValue || currentStateValue.length === 0) {
            return;
        }

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const stateValueData = currentStateValue.join(",");
        const raw = JSON.stringify({
            stateCode: stateValueData.toString(),
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
            body: raw,
        };

        fetch(`${baseUrl}/api/district`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                const localFormDataDistrict = JSON.parse(result).dataContent || [];
                const myArrayDistrict = localFormDataDistrict.map((item) => ({
                    label: item.districtName,
                    value: item.districtCode,
                    stateid: item.stateCode,
                }));

                setOptionDistrict(myArrayDistrict);

                if (districtCodeParam && districtCodeParam !== "null") {
                    const districtOption = myArrayDistrict.find(
                        (district) =>
                            String(district.value) === String(districtCodeParam)
                    );
                    if (districtOption) {
                        setDistrictValue(districtOption.value);
                        setIsDistrictDisabled(true);
                        handleChangeDistrict(districtOption);
                    }
                }
            })
            .catch((error) => console.error("Error fetching districts:", error));
    };

    const handleChange = (selectedOption) => {
        const nextValue = selectedOption ? [selectedOption.value] : [];
        setStateValue(nextValue);
        setfarmerData([]);
        setErrorMessage("");
        setInfoMessage("");
        setHasSearched(false);

        setOptionDistrict([]);
        setDistrictValue("");
        setOptionSubDistrict([]);
        setsubDistrictValue("");
        setOptionVillage([]);
        setvillageValue("");
        setIsDistrictDisabled(false);

        if (!selectedOption) {
            return;
        }

        handleState(selectedOption.value);
    };

    const handleChangeDistrict = (selectedOption) => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const userTypeValue = Number(userType);
        const userTypeCode = Number.isNaN(userTypeValue) ? 0 : userTypeValue;
        if (
            userTypeCode >= 3 &&
            districtValue &&
            (!selectedOption || String(selectedOption.value) !== String(districtValue))
        ) {
            return;
        }

        setOptionSubDistrict([]);
        setsubDistrictValue("");
        setOptionVillage([]);
        setvillageValue("");

        if (!selectedOption) {
            setDistrictValue("");
            return;
        }

        setDistrictValue(selectedOption.value);
        const stateValueData = selectedOption.stateid || stateValue[0];

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const raw = JSON.stringify({
            blockCode: 0,
            blockName: "",
            subDistrictCode: 0,
            districtCode: Number(selectedOption.value),
            visibility: 1,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
            body: raw,
        };

        fetch(`${baseUrl}/api/block`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                const localFormDataBlock = JSON.parse(result).dataContent || [];
                const myArrayBlock = localFormDataBlock.map((item) => ({
                    label: item.blockName,
                    value: item.blockCode,
                }));
                setOptionSubDistrict(myArrayBlock);
            })
            .catch((error) =>
                console.error("Error fetching blocks:", error)
            );
    };

    const handleChangeSubDistrict = (selectedOption) => {
        setvillageValue("");
        setOptionVillage([]);

        if (!selectedOption) {
            setsubDistrictValue("");
            return;
        }

        setsubDistrictValue(selectedOption.value);

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const raw = JSON.stringify({
            blockcode: selectedOption.value,
            districtcode: districtValue || 0,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
            body: raw,
        };

        fetch(`${baseUrl}/api/village`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                const localFormDataVillage = JSON.parse(result).dataContent || [];
                const myArrayVillage = localFormDataVillage.map((item) => ({
                    label: item.villageName,
                    value: item.villageCode,
                    subDistrictCode: item.subDistrictCode,
                }));
                setOptionVillage(myArrayVillage);
            })
            .catch((error) => console.log("Error fetching villages:", error));
    };

    const handleChangeVillage = (selectedOption) => {
        if (selectedOption) {
            setvillageValue(selectedOption.value);
        } else {
            setvillageValue("");
        }
    };

    const handleViewDetails = async (row) => {
        setOpenModal(true);
        setLoadingDetails(true);
        setAssetDetails(null);

        try {
            const res = await axios.post(
                `${baseUrl}/api/Asset/GetTargetAssetDetails`,
                {
                    schemeCode: Number(schemeCode),
                    stateCode: null,
                    districtCode: null,
                    subdistrictCode: null,
                    Surveyorcode: null,
                    FinancialYear: null,
                    targetId: row.original.targetId, // 👈 important
                }
            );

            if (res?.data?.success) {
                setAssetDetails(res.data.dataContent);
            } else {
                setAssetDetails([]);
            }
        } catch (err) {
            console.error(err);
            setAssetDetails([]);
        } finally {
            setLoadingDetails(false);
        }
    };

    const fetchDataFilterWise = async () => {

        if (!isSeedDemoScheme) {
            return;
        }

        setLoaderFarmer(true);
        setIsFetching(true);
        setfarmerData([]);
        setInfoMessage("");

        const toNumber = (value) => {
            const parsed = Number(value);
            return Number.isNaN(parsed) ? 0 : parsed;
        };

        const stateValueData = toNumber(stateValue?.[0] || 0);
        const districtValueData = toNumber(districtValue || 0);
        const subdistrictValueData = toNumber(subdistrictValue || 0);
        const villageValueData = toNumber(villageValue || 0);

        try {
            const result = await axios.post(
                `${baseUrl}/api/Asset/GetTargetAssetDetails`,
                {
                    schemeCode: toNumber(schemeCode || 0),
                    stateCode: stateValueData || null,
                    districtCode: districtValueData || null,
                    subDistrictCode: subdistrictValueData || null,
                    surveyorCode: null,
                    sortField: "",
                    pageNumber: 1,
                    pageSize: 1000,

                }
            );

            if (result?.data?.success) {
                const data = Array.isArray(result.data.dataContent)
                    ? result.data.dataContent
                    : [];
                setfarmerData(data);
                setInfoMessage(
                    data.length === 0 ? "No data found for the selected filters." : ""
                );
                setErrorMessage("");
            } else {
                setfarmerData([]);
                setInfoMessage("No data found for the selected filters.");
                setErrorMessage("");
            }
        } catch (error) {
            console.error("Error fetching seed demonstration data:", error);
            setfarmerData([]);
            setInfoMessage("Unable to fetch data. Please try again.");
            setErrorMessage("");
        } finally {
            setIsFetching(false);
            setLoaderFarmer(false);
        }
    };
    // Helper: get the rows currently shown in the table (respects search/sort/filter)
// and map them to plain objects using your column headers as keys.
// Helper: build export rows directly from the farmerData array (full API data)
const getExportRows = (data) => {
    return (data || []).map((original, index) => {
        return {
            "S.No": index + 1,
            "Financial Year": original.financialYear || "",
            "State": original.stateName || "",
            "District": original.districtName || "",
            "Sub District": original.subDistrictName || "",
            "Village": original.villageName || "",
            "Activity Name": original.activityName || "",
            "Component Name": original.componentName || "",
            "Major Activity Name": original.majorActivityName || "",
        };
    });
};
  const handleExportData = () => {
        const flattenObject = (obj, parentKey = "", result = {}) => {
            for (let key in obj) {
                if (!obj.hasOwnProperty(key)) continue;
                const fullKey = parentKey ? `${parentKey}.${key}` : key;

                if (
                    Array.isArray(obj[key]) &&
                    obj[key].length > 0 &&
                    typeof obj[key][0] === "object"
                ) {
                    flattenObject(obj[key][0], "", result);
                } else if (typeof obj[key] === "object" && obj[key] !== null) {
                    flattenObject(obj[key], fullKey, result);
                } else {
                    result[key] = obj[key];
                }
            }
            return result;
        };

        let exportData = farmerData?.map((item) => {
            const flattened = flattenObject(item);
            flattened.totalFarmers = Array.isArray(item?.farmers)
                ? item.farmers.length
                : 0;
            return flattened;
        });

        const allKeys = new Set();
        exportData.forEach((row) => {
            Object.keys(row).forEach((key) => allKeys.add(key));
        });

        const headers = Array.from(allKeys);

        const result = exportData.map((item) => {
            const row = {};
            headers.forEach((key) => {
                row[key] = item[key] ?? "";
            });
            return row;
        });

        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: headers,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);
    };
const handleExportToExcel = () => {
    const rowsToExport = getExportRows(farmerData);

    if (!rowsToExport.length) {
        setInfoMessage("No data available to export.");
        return;
    }

    const worksheet = XLSX.utils.json_to_sheet(rowsToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Assets Report");

    XLSX.writeFile(
        workbook,
        `AssetsReport_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
};
    const clearSearch = () => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const userTypeValue = Number(userType);
        const userTypeCode = Number.isNaN(userTypeValue) ? 0 : userTypeValue;
        const stateCode = sessionStorage.getItem("stateNameModel");
        const districtCode = sessionStorage.getItem("districtNameModel");

        setfarmerData([]);
        setErrorMessage("");
        setOptionDistrict([]);
        setOptionSubDistrict([]);
        setOptionVillage([]);
        setDistrictValue("");
        setsubDistrictValue("");
        setvillageValue("");
        setFinancialYearValue("All");
        setDemoTypeValue(null);
        setIsDistrictDisabled(false);

        if (
            userTypeCode >= 2 &&
            stateCode &&
            stateCode !== "null"
        ) {
            setStateValue([stateCode]);
            setIsStateDisabled(true);
            handleState(stateCode, userTypeCode >= 3 ? districtCode : "");
            return;
        }

        setStateValue([]);
        setIsStateDisabled(false);
    };

    const ValidateAddUser = () => {
        if (!stateValue || stateValue.length === 0) {
            setErrorMessage("Please select a State.");
            return;
        }

        setErrorMessage("");
        setInfoMessage("");
        setHasSearched(true);
        fetchDataFilterWise();
    };



    const columns = useMemo(
        () => [
             {
                header: "S.No",
                size: 0,
                Cell: ({ row }) => row.index + 1,
            },
            {
                header: "Action",
                size: 120,
                Cell: ({ row }) => (
                    <span
                        style={{ cursor: "pointer", color: "green" }}
                        onClick={() => handleViewDetails(row)}
                    >
                        👁️
                    </span>
                ),
            },
           
            {
                header: "Financial Year",
                accessorKey: "financialYear",
            },
            {
                header: "State",
                accessorKey: "stateName",
            },
            {
                header: "District",
                accessorKey: "districtName",
            },
            {
                header: "Sub District",
                accessorKey: "subDistrictName",
            },
            {
                header: "Village",
                accessorKey: "villageName",
            },
            {
                header: "Activity Name",
                accessorKey: "activityName",
            },
            {
                header: "Component Name",
                accessorKey: "componentName",
            },
            {
                header: "Major Activity Name",
                accessorKey: "majorActivityName",
            }
        ],
        []
    );

    const hasStateSelected = Array.isArray(stateValue) && stateValue.length > 0;
    const hasDistrictSelected = Boolean(districtValue);
    const hasBlockSelected = Boolean(subdistrictValue);

    const financialYearOptions = useMemo(() => {
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth();
        const fyStartYear = currentMonth < 3 ? currentYear - 1 : currentYear;
        const options = [{ value: "All", label: "All" }];

        for (let i = 0; i < 5; i += 1) {
            const startYear = fyStartYear - i;
            const endYear = startYear + 1;
            const label = `${startYear}-${endYear}`;
            options.push({ value: label, label });
        }

        return options;
    }, []);



    if (!isSeedDemoScheme) {
        return null;
    }

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarNew setHeader={setHeader} />

            <main id="main" className="main" style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 60px)', overflow: 'hidden' }}>
                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between" style={{ flexShrink: 0 }}>
                    <nav>
                        <h1>Assets Report List - {header}</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Assets Report List</li>
                            <li className="breadcrumb-item active">Assets Report</li>
                        </ol>
                    </nav>
                </div>

                <section className="section" style={{ flexShrink: 0 }}>
                    <div className="row surveydetailsBg">
                        <div className="col-md-3">
                            <label htmlFor="State" className="form-label">
                                State
                            </label>
                            <label style={{ color: "red" }}>*</label>
                            <Select
                                options={optionState}
                                value={
                                    stateValue && stateValue.length > 0
                                        ? optionState.find(
                                            (option) =>
                                                String(option.value) ===
                                                String(stateValue[0])
                                        )
                                        : null
                                }
                                onChange={handleChange}
                                isClearable={!isStateDisabled}
                                isSearchable={true}
                                isDisabled={isStateDisabled}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select State"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>
                                            {children}
                                        </components.Option>
                                    ),
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="District" className="form-label">
                                District
                            </label>
                            <Select
                                options={hasStateSelected ? optionDistrict : []}
                                value={
                                    hasStateSelected
                                        ? optionDistrict.find(
                                            (option) =>
                                                String(option.value) ===
                                                String(districtValue)
                                        )
                                        : null
                                }
                                onChange={handleChangeDistrict}
                                isClearable={!isDistrictDisabled}
                                isSearchable={true}
                                isDisabled={isDistrictDisabled}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select District"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>
                                            {children}
                                        </components.Option>
                                    ),
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="Block" className="form-label">
                                Block
                            </label>
                            <Select
                                options={hasDistrictSelected ? optionSubDistrict : []}
                                value={
                                    hasDistrictSelected
                                        ? optionSubDistrict.find(
                                            (option) =>
                                                String(option.value) ===
                                                String(subdistrictValue)
                                        )
                                        : null
                                }
                                onChange={handleChangeSubDistrict}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Block"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>
                                            {children}
                                        </components.Option>
                                    ),
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="Village" className="form-label">
                                Village
                            </label>
                            <Select
                                options={hasBlockSelected ? optionVillage : []}
                                value={
                                    hasBlockSelected
                                        ? optionVillage.find(
                                            (option) =>
                                                String(option.value) ===
                                                String(villageValue)
                                        )
                                        : null
                                }
                                onChange={handleChangeVillage}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Village"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>
                                            {children}
                                        </components.Option>
                                    ),
                                }}
                            />
                        </div>
                        {/* <div className="col-md-3">
                            <label htmlFor="financialYear" className="form-label">
                                Financial Year
                            </label>
                            <Select
                                options={financialYearOptions}
                                value={
                                    financialYearOptions.find(
                                        (option) => option.value === financialYearValue
                                    ) || financialYearOptions[0]
                                }
                                onChange={(selectedOption) =>
                                    setFinancialYearValue(
                                        selectedOption ? selectedOption.value : ""
                                    )
                                }
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Financial Year"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>
                                            {children}
                                        </components.Option>
                                    ),
                                }}
                            />
                        </div> */}


                        <div className="col-md-12 d-flex justify-content-md-center mt-3">
                            <button
                                type="button"
                                className="btn btn-primary farmrbtn me-md-2"
                                onClick={ValidateAddUser}
                            >
                                Submit
                            </button>
                            <button
                                type="button"
                                className="btn btn-success me-md-2"
                                onClick={clearSearch}
                            >
                                Clear
                            </button>
                        </div>
                    </div>

                    {errorMessage && (
                        <div className="alert alert-danger" role="alert">
                            {errorMessage}
                        </div>
                    )}
                    {!errorMessage && infoMessage && hasSearched && !isFetching && (
                        <div className="alert alert-info" role="alert">
                            {infoMessage}
                        </div>
                    )}
                </section>
                {openModal && (
                    <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title">Asset Details</h5>
                                    <button className="btn btn-danger" onClick={() => setOpenModal(false)}>X</button>
                                </div>

                                <div className="modal-body" style={{ fontSize: "13px" }}>
                                    {(() => {
                                        const detail = assetDetails?.[0];

                                        if (loadingDetails) return <p>Loading...</p>;
                                        if (!detail) return <p>No Data Found</p>;

                                        const Section = ({ title, children }) => (
                                            <div className="mb-2">
                                                <div
                                                    style={{
                                                        background: "#eef2ef",
                                                        padding: "6px 10px",
                                                        borderLeft: "3px solid green",
                                                        fontWeight: "600",
                                                        fontSize: "13px",
                                                        marginBottom: "6px"
                                                    }}
                                                >
                                                    {title}
                                                </div>
                                                <div style={{ padding: "0px 4px" }}>{children}</div>
                                            </div>
                                        );

                                        const Field = ({ label, value }) => (
                                            <div className="col-md-4 mb-2">
                                                <div style={{ fontWeight: "600", fontSize: "12px" }}>
                                                    {label}
                                                </div>
                                                <div style={{ fontSize: "13px", lineHeight: "1.2" }}>
                                                    {value || "-"}
                                                </div>
                                            </div>
                                        );

                                        return (
                                            <div className="container-fluid px-1">

                                                {/* 1. Basic Info */}
                                                <Section title="Basic Information">
                                                    <div className="row g-1">
                                                        <Field label="Financial Year" value={detail.financialYear} />
                                                        <Field label="Component" value={detail.componentName} />
                                                        <Field label="Activity" value={detail.activityName} />
                                                    </div>
                                                </Section>

                                                {/* 2. Location */}
                                                <Section title="Location Details">
                                                    <div className="row g-1">
                                                        <Field label="State" value={detail.stateName} />
                                                        <Field label="District" value={detail.districtName} />
                                                        <Field label="Sub-District" value={detail.subDistrictName} />
                                                        <Field label="Village" value={detail.villageName} />
                                                    </div>
                                                </Section>

                                                {/* 3. Activity */}
                                                <Section title="Activity Details">
                                                    <div className="row g-1">
                                                        <Field label="Major Activity" value={detail.majorActivityName} />
                                                        <Field label="Component" value={detail.componentName} />
                                                    </div>
                                                </Section>

                                                {/* 4. Surveyor */}
                                                <Section title="Surveyor Information">
                                                    <div className="row g-1">
                                                        <Field label="Name" value={detail.surveyorName} />
                                                        <Field label="Code" value={detail.surveyorCode} />
                                                        <Field label="Mobile" value={detail.mobileNumber} />
                                                    </div>
                                                </Section>

                                                {/* 5. Images */}
                                                <Section title="Images">
                                                    <div className="row g-1">
                                                        {detail.targetImage?.length ? (
                                                            detail.targetImage.map((img, i) => (
                                                                <div className="col-md-3 mb-1" key={i}>
                                                                    <img
                                                                        src={img.attPath}
                                                                        alt="asset"
                                                                        className="img-fluid rounded border"
                                                                        style={{
                                                                            height: "110px",
                                                                            objectFit: "cover"
                                                                        }}
                                                                    />
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p>No Images</p>
                                                        )}
                                                    </div>
                                                </Section>

                                            </div>
                                        );
                                    })()}
                                </div>

                            </div>
                        </div>
                    </div>
                )}

                <section className="section" style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
                    {farmerData.length > 0 ? (
                        <div className="row justify-content-lg-center" style={{ height: '100%' }}>
                            <div className="col-lg-12" style={{ height: '100%' }}>
                                <div className="card" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <div className="card-body" style={{ padding: '0', overflow: 'auto', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                        <MaterialReactTable
                                            columns={columns}
                                            data={farmerData}
                                            enableColumnOrdering
                                            enablePagination={true}
                                            state={{ isLoading: isFetching }}
                                            muiTableBodyCellProps={{
                                                sx: {
                                                    px: 1,
                                                    py: 0.5,
                                                    whiteSpace: 'nowrap',
                                                },
                                            }}
                                            muiTableHeadCellProps={{
                                                sx: {
                                                    px: 1,
                                                    py: 0.5,
                                                    whiteSpace: 'nowrap',
                                                },
                                            }}
                                            muiTableProps={{
                                                sx: {
                                                    tableLayout: 'auto',
                                                    borderCollapse: 'collapse',
                                                     minWidth: 1200,
                                                },
                                            }}
                                            renderTopToolbarCustomActions={({ table }) => (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        gap: "1rem",
                                                        p: "0.5rem",
                                                        flexWrap: "wrap",
                                                    }}
                                                >
                                                    <Button
                                                        color="primary"
                                                        onClick={() => handleExportData(table)}
                                                        startIcon={<FileDownloadIcon />}
                                                        variant="contained"
                                                    >
                                                        Export in CSV
                                                    </Button>

                                                   <button className="btn btn-outline-primary ms-2" onClick={handleExportToExcel}>
    Download Excel
</button>
                                                </Box>
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </section>

                {LoaderFarmer ? (
                    <div className="overlay">
                        <div className="overlay__inner">
                            <div className="overlay__content">
                                <span className="spinner"></span>
                            </div>
                        </div>
                    </div>
                ) : null}
            </main>

            <AdminFooterNew />
        </>
    );
};

export default AssetsReports;
